import React, { useContext } from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';
import { LOGO_TYPE } from '../themeUtils';
import EAIcon from '../../../../components/common/EAIcon';
import { useWatch } from 'react-hook-form';
import { Context } from '../../../../states/Store';

const Preview = ({ logoTypes, control, preview = [], hasRemovedLogo = false }) => {
  const { classes } = useStyles();
  const [state] = useContext(Context);
  const colorPrimary = useWatch({ control, name: `colorPrimary` });
  const colorHover = useWatch({ control, name: `colorHover` });
  const colorBackground = useWatch({ control, name: `colorBackground` });
  const logoText = useWatch({ control, name: `logoText` });
  const logoFontWeight = useWatch({ control, name: `logoFontWeight` });
  const logoColor = useWatch({ control, name: `logoColor` });

  return (
    <div className={classes.previewWrapper}>
      <div className={classes.previewContainer}>
        <div className={classes.previewContent}>
          <div className={classes.previewContentHeader}>
            {logoTypes === LOGO_TYPE.TEXTE &&
              <div
                className={classes.previewContentNavigationLogo}
                style={{ fontWeight: logoFontWeight || 400, color: logoColor }}
              >
                {logoText}
              </div>
            }
            {logoTypes === LOGO_TYPE.IMAGE &&
              <div
                className={classes.previewContentNavigationLogo}
                style={{ fontWeight: 900, color: "black" }}
              >
                {preview.length > 0
                  ? (
                    <img
                      src={preview[0].preview}
                      style={{ maxWidth: '60px', maxHeight: '40px' }}
                      // Revoke data uri after image is loaded
                      onLoad={() => {
                        URL.revokeObjectURL(preview[0].preview)
                      }}
                      alt={"logo"} />
                  )
                  : state.personalization.logoURI && !hasRemovedLogo ? (
                    <img
                      src={state.personalization.logoURI}
                      alt="logo"
                      style={{ maxWidth: '60px', maxHeight: '40px' }}
                    />
                  ) :  <EAIcon icon={'personalization/aprovallNormal'} style={{ maxWidth: '60px', maxHeight: '40px'}} />
                }
              </div>
            }
            <div
              className={classes.previewContentHeaderAvatar}
              style={{ backgroundColor: colorHover }}
            />
          </div>
          <div className={classes.previewContentMainWreapper}>
            <div className={classes.previewContentNavigation}>
              <div className={classes.previewContentNavigationItemsWrapper}>
                <div className={classes.previewContentNavigationItemDark} />
                <div className={classes.previewContentNavigationItemLight} />
                <div className={classes.previewContentNavigationItemLight} />
                <div className={classes.previewContentNavigationItemLight} />
              </div>
              <div className={classes.previewContentNavigationItemsWrapper}>
                <div className={classes.previewContentNavigationItemDark} />
                <div className={classes.previewContentNavigationItemLight} />
              </div>
            </div>
            <div
              className={classes.previewContentMain}
              style={{ backgroundColor: colorBackground }}
            >
              <div className={classes.previewContentMainCardsWrapper}>
                <div className={classes.previewContentMainCardItem}>
                  <EAIcon icon={"personalization/personalizationCard1"} noTransform/>
                </div>
                <div className={classes.previewContentMainCardItem}>
                  <EAIcon icon={"personalization/personalizationCard2"} noTransform/>
                </div>
                <div className={classes.previewContentMainCardItem}>
                  <EAIcon icon={"personalization/personalizationCard3"} noTransform/>
                </div>
              </div>
              <div className={classes.previewContentMainFooterWrapper}>
                <div className={classes.previewContentMainFooterBar} />
                <div
                  className={classes.previewContentMainFooterBtn}
                  style={{ backgroundColor: colorPrimary }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Preview;